import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("crs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/signup") && !path.startsWith("/forgot-password") && !path.startsWith("/reset-password") && path !== "/" && !path.startsWith("/pricing") && !path.startsWith("/knowledge") && !path.startsWith("/about") && !path.startsWith("/contact") && !path.startsWith("/calculator")) {
        localStorage.removeItem("crs_token");
        localStorage.removeItem("crs_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
